module.exports = __webpack_public_path__ + "media/images/grade/C-cece8b823cace8728569a21cfa0b34bc.svg";